import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../routes';
import AutoBind from 'react-autobind';
import { Switch } from './Switch';
import Modal from '../../util/modal';
import Modal2 from '../../util/modal/CancelarCFDI';
import { FormGroup } from '../../util/form-group';
import { FormGroup2 } from '../../util/form-group';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { Factura_Contado_Individual, Factura_Credito_IndividualSoloUna, Factura_Fiscal_PDF_Listkey, Factura_Fiscal_XML_Listkey, Factura_Anulacion } from '../../request/rfc';

export default class Consulta extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            factura: '',
            folioUID: '',
            modalSucursal: '',
            modalFolio: '',
            serie: '',
            showModal: false,
            showModal2: false,
            disabled: false,
            versionCFDI: '',
            MensajeError: '',
            Ocultar: 'hidden',
            Data: {}
            /*liberaTicket: false*/

        };
        AutoBind(this);
    }

    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    onchangeLiberaTicket(checked) {

        this.setState({ liberaTicket: checked });

    }
    onXML() {
        const { modalSucursal, modalFolio } = this.state;
        Factura_Fiscal_XML_Listkey({ pSucursal: modalSucursal, pFolio: modalFolio })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/octet-stream,${encodeURIComponent(Data.XML_Archivo)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', `${Data.Fiscal_NumeroFactura}.xml`);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });
    }

    onPDF() {
        const { modalSucursal, folioUID } = this.state;
        Factura_Fiscal_PDF_Listkey({ pSucursal: modalSucursal, pFolio: folioUID })
            .then(({ data: Response }) => {
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const pdf = `data:application/pdf;base64,${encodeURIComponent(Data.Documento)}`;
                    var element = document.createElement('a');
                    element.setAttribute('href', pdf);
                    element.setAttribute('download', Data.Nombre);
                    element.style.display = 'none';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
            })
            .catch((err) => { console.log(err); });


    }

    Aceptar() {
        const { Data, sucursal, factura } = this.state;
        console.log(Data, this.state.Data, 'acpe')
        Factura_Anulacion({ pSucursal: sucursal, pFactura: factura, pRegimenFiscalCancelacion: "02", pUUID: this.state.Data.UUID })

            .then(({ data: Response }) => {
                this.setState({ anulacionDisabled: false });
                const { Message, Data } = Response;
                if (Message !== '') {
                    alert(Message);
                } else {
                    const { Exitoso, Mensaje_Error, Codigo_Error, Anulacion_EstadoCFDI, Anulacion_SubEstadoCFDIServicio,
                        Anulacion_EstadoCFDIServicio, Anulacion_HorasSolicitudCFDI } = Data;
                    alert("Exitoso:" + Exitoso);
                    if (!Exitoso) {
                        alert("Error: " + Mensaje_Error + ". Código:" + Codigo_Error);
                    } else {
                        switch (Anulacion_EstadoCFDI) {
                            case "EN PROCESO":
                                alert("La factura sigue en Proceso de Anulación. Estado CFDI:" + Anulacion_EstadoCFDI + " Estado SAT:" + Anulacion_EstadoCFDIServicio + " SubEstado SAT:" + Anulacion_SubEstadoCFDIServicio + " Horas solicitud de anulación:" + Anulacion_HorasSolicitudCFDI);
                                break;
                            case "APLICADO":
                                alert("La Factura ha sido Anulada. Estado CFDI: " + Anulacion_EstadoCFDI);
                                break;
                            default:
                                alert("Estado CFDI: " + Anulacion_EstadoCFDI)
                                break;
                        }
                        this.onClean();
                    }
                }
            })
            .catch((err) => { console.log(err); this.setState({ anulacionDisabled: false }); });

    }

    onCloseModal2() {
        this.setState({ showModal2: false });
    }

    onCloseModal() {
        this.setState({ showModal: false });
    }

    onSubmit(e) {
        e.preventDefault();
        const { sucursal, caja, factura } = this.state;
        const { tipoFactura } = this.props.match.params;

        if (sucursal === '' || caja === '' || factura === '') {
            alert('Debe ingresar los valores de Sucursal, Caja y Número Factura para poder realizar la consulta.');
            return;
        } else {
            this.setState({ disabled: true });
            const { cliente, correo, usocfdi, versionCFDI } = this.props.match.params;
            const params = {
                pClienteFiscalId: cliente, pCorreo: correo,
                pUsoCFDI: usocfdi, pSucursal: sucursal, pCaja: caja, pFactura: factura, pversionCFDI: versionCFDI 
            };

            //if(tipoFactura == '0') {
            Factura_Contado_Individual(params)
                .then(this.manageResponseConsulta)
                .catch((err) => { console.log(err); this.setState({ disabled: false }); });
            //} else {
            //    Factura_Credito_IndividualSoloUna(params)
            //    .then(this.manageResponseConsulta)
            //    .catch((err) => { console.log(err); this.setState({ disabled: false }); });
            //}

        }

        this.setState({ disabled: false });

    }
     
    manageResponseConsulta({ data: Response }) {
        const { Message, Data } = Response;
        if (Message !== '') {
            alert(Message);
            if (parseInt(Data.Codigo_Error) == 3) {
                this.setState({ MensajeError: Message, Ocultar: "hidden", showModal2: true, Data: Data });
                console.log('hola')
            }else if (parseInt(Data.Codigo_Error) >= 5) {
                    this.setState({ MensajeError: Message, Ocultar: "text" });
            } else {
                this.setState({ MensajeError: Message, Ocultar: "hidden" });
            }
            this.setState({ disabled: false });
        } else {
            alert('Se generó correctamente la factura.');
            this.setState({
                showModal: true, serie: Data.Serie, modalFolio: Data.NumeroFactura,
                folioUID: Data.UUID, modalSucursal: Data.Suc_Id
            });
        }
    }

    render() {

        const { baseUrl, sucursal, caja, factura, showModal, modalSucursal, modalFolio, disabled, serie, MensajeError, Ocultar, showModal2 } = this.state;
        const linkStyle = { 'pointerEvents': disabled ? 'none' : 'auto' };
        const cssClassSpin = disabled ? 'fas fa-spinner fa-spin' : 'fas fa-save';
        const onCheked = false;//general.General_Site_Interno === "SI" ? true : false;
        return (
            <Fragment>
                <div className="row" id="consulta">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right" style={linkStyle}>
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <form className="col-md-12" onSubmit={this.onSubmit}>
                                <div className="row">
                                    <FormGroup col="col-md-4"
                                        className="form-control"
                                        type="text"
                                        name="sucursal"
                                        label="Sucursal"
                                        value={sucursal}
                                        readOnly={disabled}
                                        onChange={this.onChange} />

                                    <FormGroup col="col-md-4"
                                        className="form-control"
                                        type="text"
                                        name="caja"
                                        label="Caja"
                                        value={caja}
                                        readOnly={disabled}
                                        onChange={this.onChange} />

                                    <FormGroup col="col-md-4"
                                        className="form-control"
                                        type="text"
                                        name="factura"
                                        label="Ticket"
                                        value={factura}
                                        readOnly={disabled}
                                        onChange={this.onChange} />


                                </div>
                                <div className="row">
                                    <FormGroup2 col="col-md-12"
                                        className="form-control"
                                        type={Ocultar}
                                        name="mensajeError"
                                        value={MensajeError}
                                        readOnly={true}/>
                                </div>
                                <div className="row">
                                    <div className="form-group col-md-12">
                                        <button type="submit" className="btn btn-custom-theme margin-top-30 ml-sm-3 float-right" disabled={disabled} >
                                            <i className={cssClassSpin}></i>
                                        </button>
                                    </div>
                                </div>
                                
                            </form>
                        </div>
                    </div>
                </div>
                <Modal show={showModal}
                    serie={serie}
                    folio={modalFolio}
                    onXML={this.onXML}
                    onPDF={this.onPDF}
                    onCloseModal={this.onCloseModal}
                />
                <Modal2 show={showModal2}
                    Aceptar={this.Aceptar}
                    onCloseModal2={this.onCloseModal2}
                />
            </Fragment>
        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/ticket/index.jsx